import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OfferService, OfferInputDto, StoreService, StoreOutputDto } from 'src/generated_client';
import { SnackBarService } from '../../../../services/snack-bar.service';
import { DatePipe } from '@angular/common';
import { OfferUpdateDto } from 'src/generated_client/model/offerUpdateDto';
import * as moment from 'moment';

@Component({
  selector: 'app-add-discount',
  templateUrl: './add-discount.component.html',
  styleUrls: ['./add-discount.component.css']
})

export class AddDiscountComponent implements OnInit {

  id: any;
  isEdit: boolean = false;
  title: string = "";
  minDate = new Date();
  dateTo: any;
  allStores: StoreOutputDto[] = [];


  status = [
    { value: true, viewValue: 'Activa' },
    { value: false, viewValue: 'Desactivada' },
  ];

  discountType = [
    { value: 0, viewValue: 'En %' },
    { value: 1, viewValue: 'Monto fijo' },
  ]

  discountOnDeliver = [
    { value: true, viewValue: 'Sí' },
    { value: false, viewValue: 'No' },
  ]

  addDiscountForm: FormGroup = this.fb.group({
    code: ['', Validators.required],
    description: ['', Validators.compose([Validators.pattern('[a-zA-Z ]*'), Validators.required])],
    minValue: ['', Validators.min(1)],
    type: [0, Validators.required],
    value: ['', Validators.compose([Validators.required, Validators.min(1)])],
    maxDate: [''],
    upTo: ['', Validators.min(1)],
    status: [false, Validators.required],
    storeList: ['', Validators.required],
    onDeliver: [false, Validators.required],
  })

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private service: OfferService,
    private storeService: StoreService,
    private route: Router,
    private snack: SnackBarService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {

    this.id = this.activatedRoute.snapshot.paramMap.get("id")

    this.isEdit = (this.id != null);

    this.changeTitle();

    this.storeService.apiStoreGetAllStoresGet().subscribe(x => {
      this.allStores = x;
    });

    if (this.isEdit)
      this.SetControls();
  }

  private SetControls() {
    this.service.apiOfferGetOneGet(this.id).subscribe(x => {
      this.addDiscountForm.controls['code'].setValue(x.dsCode);
      this.addDiscountForm.controls['description'].setValue(x.dsDescription);
      this.addDiscountForm.controls['minValue'].setValue(x.qtMinCartValue);
      this.addDiscountForm.controls['type'].setValue(x.nmType);
      this.addDiscountForm.controls['value'].setValue(x.qtValue);
      this.addDiscountForm.controls['status'].setValue(x.isEnabled);
      this.addDiscountForm.controls['storeList'].setValue(x.cdsStores);
      this.addDiscountForm.controls['onDeliver'].setValue(x.isShipping);
      this.addDiscountForm.controls['upTo'].setValue(x.qtUpto);
      this.addDiscountForm.controls['maxDate'].setValue(this.datePipe.transform(x.dtValidTill, 'yyyy-MM-dd'));

    });
  }

  inpuDateTo(event: any) {
    this.dateTo = event.value;
  }

  public saveChanges(form: any) {

    if (!this.isEdit) {

      let input: OfferInputDto = {
        dsCode: form.code,
        dsDescription: form.description,
        qtMinCartValue: Number(form.minValue),
        nmType: form.type,
        qtValue: form.value,
        isEnabled: form.status,
        qtUpto: form.upTo,
        isShipping: form.onDeliver,
        cdsStores: form.storeList,
        dtValidTill: new Date(form.maxDate)
      };

      this.service.apiOfferPostOfferPost(input).subscribe(() => {

        this.snack.openSnackBar("Descuento agregado correctamente", 'Aceptar');
        this.route.navigate(['discount-management']);
      },
        err => {
          this.snack.openSnackBar(err.error.error, 'Aceptar');
        }
      );
    }
    else {
      
      let dateTo = moment(this.dateTo);

      let updateDto: OfferUpdateDto = {
        cdOffer: Number(this.id),
        dsCode: form.code,
        dsDescription: form.description,
        qtMinCartValue: Number(form.minValue),
        nmType: form.type,
        qtValue: form.value,
        qtUpto: form.upTo,
        isEnabled: form.status,
        isShipping: form.onDeliver,
        dtValidTill: dateTo.toDate(),
        cdsStores: form.storeList
      };

      this.service.apiOfferEditOfferPut(updateDto).subscribe(
        x => {
          this.snack.openSnackBar("Descuento editado correctamente", 'Aceptar');
          this.route.navigate(['discount-management']);
        },
          err => {
            this.snack.openSnackBar(err.error.error, 'Aceptar');
          }
        );
    }
  }

  private changeTitle() {
    if (this.isEdit) {
      this.title = "EDITAR DESCUENTO";
    }
    else {
      this.title = "AGREGAR NUEVO DESCUENTO";
    }
  }

}